import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

class Navigation extends Component {
  state = {
    isAuthenticated: false,
  };

  onLogoutClick = e => {
    e.preventDefault();
    const { firebase } = this.props;
    firebase.logout();
  };

  render() {
    const { navigation } = this.props;
    const { isAuthenticated } = this.state;

    return (
      <header className="header header-shrink header-inverse fixed-top">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <span className="logo-default">
                <img src="/images/logo/vkri-logo.svg" alt="Logo Vespa klub Rijeka" style={{ height: '80px' }} />
              </span>
              <span className="logo-inverse">
                <img src="/images/logo/vkri-logo.svg" alt="Logo Vespa klub Rijeka" style={{ height: '80px' }} />
              </span>
            </a>

            <button className="navbar-toggler p-0" data-toggle="collapse" data-target="#navbarNav">
              <div className="hamburger hamburger--spin js-hamburger">
                <div className="hamburger-box">
                  <div className="hamburger-inner" />
                </div>
              </div>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ml-auto">
                {navigation.map(({ title, link }) => (
                  <li className="nav-item" key={link}>
                    <NavLink to={link} className="nav-link">
                      {title}
                    </NavLink>
                  </li>
                  // <li className="nav-item" key={link}>
                  //   <a className="nav-link" href={link}>
                  //     {title}
                  //   </a>
                  // </li>
                ))}

                {isAuthenticated ? (
                  <li className="nav-item">
                    <a
                      className="nav-link btn btn-sm btn-rounded btn-red u-w-110"
                      href="#!"
                      onClick={this.onLogoutClick}
                    >
                      Logout
                    </a>
                  </li>
                ) : (
                  <li className="nav-item">
                    <a className="nav-link btn btn-sm btn-rounded btn-red u-w-110" href="/members">
                      Za članove
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

export default compose(
  firebaseConnect(),
  connect(state => ({
    auth: state.firebase.auth,
  }))
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js